// extracted by mini-css-extract-plugin
var _1 = "_projectManagementCreateProjectForm-module__button-container";
var _2 = "_projectManagementCreateProjectForm-module__button-subcontainer";
var _3 = "_projectManagementCreateProjectForm-module__container";
var _4 = "_projectManagementCreateProjectForm-module__container-justify-end";
var _5 = "_projectManagementCreateProjectForm-module__form-container";
var _6 = "_projectManagementCreateProjectForm-module__joint-account-details-container";
var _7 = "_projectManagementCreateProjectForm-module__span-2";
export { _1 as "button-container", _2 as "button-subcontainer", _3 as "container", _4 as "container-justify-end", _5 as "form-container", _6 as "joint-account-details-container", _7 as "span-2" }
